import { FC, memo } from 'react';
import { Collapsible as ChakraCollapsible } from '@chakra-ui/react';

import { CollapsibleProps } from './types/CollapsibleProps';

const CollapsibleComponent: FC<CollapsibleProps> = ({
  children,
  content,
  ...props
}) => (
  <ChakraCollapsible.Root {...props}>
    {children && (
      <ChakraCollapsible.Trigger asChild>{children}</ChakraCollapsible.Trigger>
    )}
    <ChakraCollapsible.Content>{content}</ChakraCollapsible.Content>
  </ChakraCollapsible.Root>
);

export const Collapsible = memo(CollapsibleComponent);
